export default __webpack_public_path__ + "static/ASLA_LiniaLounge_2-b8dfaab49c87fb6a21dcc22da68cd3dd.png";